import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { topicMeta } from "@/lib/topicMeta";

export const TopicGrid = ({ topics }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {topics.map((t, i) => {
        const { Icon, color, bg } = topicMeta(t.icon_key);
        return (
          <Link
            key={t.id}
            to={`/topic/${t.slug}`}
            data-testid="topic-card"
            className="group relative bg-white rounded-2xl border border-slate-200 p-6 sm:p-7 hover:border-slate-300 hover:shadow-xl hover:shadow-slate-900/5 hover:-translate-y-1 transition-all animate-fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="flex items-start justify-between">
              <span
                className="grid place-items-center w-12 h-12 rounded-xl"
                style={{ backgroundColor: bg, color }}
              >
                <Icon className="w-6 h-6" />
              </span>
              <span className="text-xs font-semibold text-slate-400">
                {t.article_count} {t.article_count === 1 ? "article" : "articles"}
              </span>
            </div>
            <h3 className="font-heading text-xl font-semibold text-slate-900 mt-5">{t.name}</h3>
            <p className="text-sm text-slate-500 mt-2 leading-relaxed line-clamp-2">
              {t.description}
            </p>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1A73E8] mt-4 group-hover:gap-2.5 transition-all">
              Explore <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        );
      })}
    </div>
  );
};
